import {Fragment, useState} from "react";
import {TableComponent} from "../../Global/AgGridTableComponent";
import {URL_API} from "../../Constants/Const";

export function ShowAllManualComponent({open=null}){

    const [ manuals] = useState([]);

    const [documentSelected, setDocumentSelected] = useState(null);

    const [documentShow, setDocumentShow] = useState(null)


    const MANUAL_COLUMS =[
        { headerName: '#', field: 'id', flex: 1 },
        { headerName: 'Nombre', field: 'name_file', flex: 1 },
        { headerName: 'Fecha Registrado', field: 'date_create', flex: 1 },
        { headerName: 'Activo', field: 'activate', flex: 1 },
    ]

    const handlingShowManual = (manual) => {
        setDocumentSelected(manual.data)
        setDocumentShow(`${URL_API}show-manual-id/${manual.data.id}/`);
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }


    return(

        <Fragment>
            <TableComponent
                // titleTable="Todos los manuales"
                rowsTable={manuals}
                columnsTable={MANUAL_COLUMS}
                handlingDoubleClick={handlingShowManual}
            />
            {
                documentSelected && documentShow &&
                <iframe title="document"
                        src={documentShow}
                        style={{width:"100%",height:"500px", marginTop: "3vh"}}/>
            }
        </Fragment>
    );
}